import cloneDeep from "lodash.clonedeep";

import { ActionTypes } from "store/actionTypes";
import SupervisorState from "models/state/supervisorState";
import Action from "store/action";
import { getApiErrorMessage } from "../utils/apiErrorMessage";

const initialState = {
  isLoading: false,
  error: null,
  tickets: [],
  totalCount: 0,
  selectedTicket: null,
  technicianGroupList: [],
  technicianGroupListLoaded: false,
  technicianList: [],
  ninjaoneBoardList: [],
  ninjaBoardListLoaded: false,
  ninjaoneUsers: [],
  isRefreshing: false,
};

const reducer = (
  state: SupervisorState | undefined = initialState,
  action: Action
) => {
  let newState = cloneDeep(state);

  const resolveTotalCount = (payload: any) => {
    if (!payload) {
      return 0;
    }
    const candidates = [
      payload.totalCount,
      payload.total_count,
      payload.record_count,
      payload.metadata?.totalCount,
      payload.metadata?.total_count,
      payload.pageDetails?.totalCount,
    ];

    for (const candidate of candidates) {
      if (typeof candidate === "number" && Number.isFinite(candidate)) {
        return candidate;
      }
      if (typeof candidate === "string") {
        const parsed = Number.parseInt(candidate, 10);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
    }

    if (Array.isArray(payload.tickets)) {
      return payload.tickets.length;
    }

    return 0;
  };

  switch (action.type) {
    case ActionTypes.SUPERVISOR_LOADING:
      newState.isLoading = true;
      newState.error = null;
      return newState;

    case ActionTypes.SUPERVISOR_ERROR:
      newState.isLoading = false;
      newState.error = getApiErrorMessage(action.payload?.error, "Unable to load tickets.");
      return newState;

    case ActionTypes.GET_TICKETS:
      newState.isLoading = false;
      newState.error = null;
      newState.tickets = action.payload.tickets;
      newState.totalCount = resolveTotalCount(action.payload);
      return newState;

    case ActionTypes.GET_TICKET_BY_ID:
      newState.isLoading = false;
      newState.error = null;
      newState.selectedTicket = action.payload;
      return newState;

    case ActionTypes.GET_TECHNICIAN_GROUP_LIST:
      newState.isLoading = false;
      newState.technicianGroupList = action.payload;
      newState.technicianGroupListLoaded = true;
      return newState;

    case ActionTypes.GET_TECHNICIAN_LIST:
      newState.isLoading = false;
      newState.technicianList = action.payload;
      return newState;

    case ActionTypes.GET_NINJAONE_BOARD_LIST:
      newState.isLoading = false;
      newState.ninjaoneBoardList = action.payload;
      newState.ninjaBoardListLoaded = true;
      return newState;

    case ActionTypes.GET_NINJAONE_USERS:
      newState.isLoading = false;
      newState.ninjaoneUsers = action.payload;
      return newState;

    case ActionTypes.REFRESH_TICKET_DATA:
      newState.isRefreshing = true;
      return newState;

    case ActionTypes.TICKET_REFRESHING:
      newState.isRefreshing = action.payload;
      return newState;

    default:
      return newState;
  }
};

export default reducer;
